<template>
  <svg viewBox="0 0 21 21"><g fill-rule="nonzero"><path d="M4 .25a.75.75 0 01.743.648L4.75 1v3a.75.75 0 01-1.493.102L3.25 4V1A.75.75 0 014 .25zM8 .25a.75.75 0 01.743.648L8.75 1v3a.75.75 0 01-1.493.102L7.25 4V1A.75.75 0 018 .25zM12 .25a.75.75 0 01.743.648L12.75 1v3a.75.75 0 01-1.493.102L11.25 4V1A.75.75 0 0112 .25zM16 .25a.75.75 0 01.743.648L16.75 1v3a.75.75 0 01-1.493.102L15.25 4V1A.75.75 0 0116 .25zM19 7.25a.75.75 0 01.102 1.493L19 8.75H1a.75.75 0 01-.102-1.493L1 7.25h18z" /><path d="M17 2.25H3A2.75 2.75 0 00.25 5v12A2.75 2.75 0 003 19.75h14A2.75 2.75 0 0019.75 17V5A2.75 2.75 0 0017 2.25zM3 3.75h14c.69 0 1.25.56 1.25 1.25v12c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25z" /></g></svg>
</template>

<script>
export default {
  name: 'Calendar'
}
</script>
